"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobDaysSinceChange = void 0;
const typeorm_1 = require("typeorm/browser");
const job_1 = require("./job");
const data_ui_1 = require("../data-ui");
const contact_profile_enum_1 = require("./contact-profile-enum");
let JobDaysSinceChange = class JobDaysSinceChange {
};
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], JobDaysSinceChange.prototype, "jobId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], JobDaysSinceChange.prototype, "actionsTaken", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Date)
], JobDaysSinceChange.prototype, "latestAction", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], JobDaysSinceChange.prototype, "priority", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], JobDaysSinceChange.prototype, "daysSinceLastStatusChange", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => job_1.Job, (job) => job.jobDaysSinceChange),
    (0, typeorm_1.JoinColumn)({ name: 'job_id' }),
    __metadata("design:type", job_1.Job)
], JobDaysSinceChange.prototype, "job", void 0);
JobDaysSinceChange = __decorate([
    data_ui_1.DataUi.Permissions(contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER),
    data_ui_1.DataUi.Name({
        name: 'Job Days Since Change',
        nameProperties: ['jobId'],
    }),
    (0, typeorm_1.ViewEntity)({
        expression: `
  SELECT job_id, -- version 5
    actions_taken,
    days_since_last_action_taken,
    latest_action,
    days_since_last_status_change,
    (
        SELECT CASE
                WHEN actions_taken = 0 THEN days_since_last_status_change * 2
                WHEN actions_taken > 0 THEN days_since_last_status_change + days_since_last_action_taken
                ELSE days_since_last_status_change
            END
    ) priority
FROM (
        SELECT j.api_id__c job_id,
        (
                SELECT count(c.*)
                FROM public.comment c
                WHERE NOT (c.action_type = 'generic')
                    AND c.job_api_id = j.api_id__c
                    AND c.created_at > (
                        SELECT logs.time_stamp
                        FROM public.log_entries logs
                        WHERE logs.event_type IN ('new_status', 'create')
                            AND logs.job_api_id = j.api_id__c
                        ORDER BY logs.time_stamp DESC
                        LIMIT 1
                    )
            ) actions_taken, (
                SELECT LEAST(
                        DATE_PART('day', (NOW () - c.created_at)),
                        0
                    )
                FROM public.comment c
                WHERE c.job_api_id = j.api_id__c
                    AND NOT (c.action_type = 'generic')
                    AND c.created_at > (
                        SELECT logs.time_stamp
                        FROM public.log_entries logs
                        WHERE logs.event_type IN ('new_status', 'create')
                            AND logs.job_api_id = j.api_id__c
                        ORDER BY logs.time_stamp DESC
                        LIMIT 1
                    )
                LIMIT 1
            ) days_since_last_action_taken, (
                SELECT c.created_at
                FROM public.comment c
                WHERE c.job_api_id = j.api_id__c
                    AND NOT (c.action_type = 'generic')
                ORDER BY c.created_at DESC
                LIMIT 1
            ) latest_action, (
                SELECT CASE
                        WHEN j.status__c IN (
                            'accepted',
                            'appointment confirmed'
                        )
                        AND (
                            j.readiness_date__c IS NOT NULL
                            OR j.date_expected__c IS NOT NULL
                            OR j.appointment_customer_start__c IS NOT NULL
                        ) THEN LEAST(
                            delta,
                            GREATEST(
                                DATE_PART(
                                    'day',
                                    (
                                        NOW () - GREATEST(
                                            j.readiness_date__c,
                                            j.date_expected__c,
                                            j.appointment_customer_start__c
                                        )
                                    )
                                ),
                                0
                            )
                        )
                        WHEN j.status__c IN ('cancelled', 'closed', 'invoice sent', 'completed') THEN NULL
                        ELSE delta
                    END
                FROM (
                        SELECT DATE_PART(
                                'day',
                                (NOW () - logs.time_stamp)
                            ) as delta
                        FROM public.log_entries logs
                        WHERE (
                                logs.job = j.sfid
                                OR logs.job_api_id = j.api_id__c
                            )
                            and logs.new_values->'job'->'status' != logs.old_values->'job'->'status'
                        ORDER BY logs.time_stamp DESC
                        LIMIT 1
                    ) as delta_query
            ) days_since_last_status_change
        FROM public.job__c j
    ) t
  `,
    })
], JobDaysSinceChange);
exports.JobDaysSinceChange = JobDaysSinceChange;
//# sourceMappingURL=job-days-since-change.js.map